<template>
  <div :id="this.id"
       class="sitebuilder-element-container"
       element="CheckoutComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :data-tag="dataTag()"
       :style="style()">

    <div ref="mountingPoint" class="s-checkout-widget pt-2"></div>
    </div>
</template>

<script>

	import Data from './Model';
	import {apiUrl} from './scTools'

	export default {
		name: 'CheckoutComponent',
		props: ['config', 'id', 'preview', 'device'],
		data() {
			return Data.data();
		},
    methods: {
      build(config) {
        this.internal_config = {...this.internal_config, ...config};
      },
      dataTag() {
        if (this.internal_config.tag) {
          return this.internal_config.tag;
        }
        return '';
      },
      style() {
        return `
          left:  ${this.internal_config.left};
          width:  ${this.internal_config.width};
          z-index: ${this.internal_config.zIndex};
          max-width: ${this.internal_config.maxWidth};
          margin: 0 auto;
          top: ${this.internal_config.top};
        `;
      },
      updateHeightParent() {
        let jqElement = $('#' + this.id);
        let heightFinal = parseInt(jqElement.css('height')) + parseInt(jqElement.css('top'));

        if (parseInt(this.$parent.height) < heightFinal) {
          this.$parent.internal_config.height = heightFinal + 'px';
        }
      },
      apiUrl,

      loadAssets() {
        window.checkoutConfigs = {baseURL: this.apiUrl(), data: {...this.internal_config}}

        this.$refs.mountingPoint.innerHTML = ''
        let mount = document.createElement('div')
        mount.classList.add('sc-widget')
        mount.setAttribute('data-version', this.internal_config.version)
        this.$refs.mountingPoint.appendChild(mount)
        this.$nextTick(() => {
          // load translations
          let trans = document.createElement('script')
          trans.src =` ${window.checkoutConfigs.baseURL}/lang/${this.internal_config.language}?scope=checkoutTranslations`
          trans.onload = () => {
            // load js
            let js = document.createElement('script')
            js.src = `${window.checkoutConfigs.baseURL}/widget/app.js?v=${this.internal_config.version}`
            document.body.appendChild(js)
          }
          document.body.appendChild(trans)
        })
      },
    },

    mounted() {
      this.build(this.$props.config);
      this.loadAssets();

      setInterval(this.updateHeightParent, 3000);
    }
  }
</script>
